import React, { useEffect, useMemo, useState } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import messages from './Messages';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import '../../../../basics/Object';
import { LoadingLine } from '../../TasksManagement/LoadingLine';
import { navigate } from '@reach/router';
import {
  isANumber,
  convertNumbersToProperFormat,
  convertDigitToProperFormat,
} from '../../../../utils/number';
import {
  getMyClasses,
  getMyClassesFn,
  getMyManagingPDPInTerm,
  getMyPDPInTerm,
  queryClasses,
  queryClassesFn,
} from '../../../../store/pdp/pdpSlice';
import { PDPProblems } from '../PDPPersonManager/PDPPersonManager';
import { PDPPersonEditor } from '../PDPPersonManager/PDPPersonEditor';
import { IOption } from '../../../../components/Select/Select';
import { ClassOverviewWrapper } from '../PDPTerms/style';
import CompanyMemberSelect from '../../../../components/FileManager/ItemsViewer/Survey/SurveyEditor/CompanyMemberSelect/CompanyMemberSelect';
import Collapsible from '../../../../components/Collapsible';
import Icon from '../../../../components/Icon';
import {
  CompanyPDPState,
  ParticipantStatus,
  PDPClass,
  Term,
} from '../../../../store/pdp/types';
import { ITags, ITagView } from '../../../../store/providers/providerTypes';
import {
  CompanyPDP,
  ICompany,
  ICompanyMember,
  PdpOutputConfig,
} from '../../../../store/companies/companiesTypes';
import {
  appDispatch,
  IThisUser,
  IUsers,
  RootState,
} from '../../../../store/store';
import { IAnalyticsQuery } from '../../../../store/entity/IAnalyticsQuery';
import { IAnalyticResponse } from '../../../../store/entity/IAnalyticResponse';
import { getAnalyse } from '../../../../store/survey/surveySlice';
import { requireSeveralUser } from '../../../../store/users/usersSlice';
import Select from '../../../../components/Select';
import Input from '../../../../components/Input';
import Button from '../../../../components/Button';
import ExportExcell from './ExportExcell';
import moment from 'moment-jalaali';
import { getEffectivity } from './ClassMemberViewer';
import { smartDateDuration } from '../../../../utils/date';
import i18n, { languageDirection } from '../../../../i18n';
import { Box } from '../../Inbox/styles';
import UserMixpanel from 'utils/mixpanel/MixpanelClass';

interface IOwnProps {
  termId: number;
  companyPDP: CompanyPDP;
  pdpState: CompanyPDPState;
  defaultUserId?: number;
  thisUserId: number;
  companyId: number;
  isAdmin: boolean;
  pdpId: number;
}

interface IStateToProps {
  users: IUsers['map'];
  company: ICompany;
  thisUser: IThisUser;
  classes: PDPClass[];
  tags: ITags['data'];
}
interface DispatchToProps {
  getMyPDPProgram: (termId: number, pdpId: number) => any;
  getMyManagingPDPProgram: (termId: number, pdpId: number) => Promise<Term>;
  getAnalyse: (
    dataQuery: IAnalyticsQuery,
    surveyToken?: string,
    ownerToken?: string,
    reportToken?: string
  ) => Promise<{ result: IAnalyticResponse }>;
  requireSeveralUser: (usersList: number[]) => Promise<void>;
  queryClasses: (
    pdpId: number,
    startDate?: number,
    endDate?: number,
    isTemplate?: boolean,
    termId?: number,
    showDeleted?: boolean
  ) => ReturnType<typeof queryClassesFn>;

  getMyClasses: (
    termId: number,
    pdpId: number
  ) => ReturnType<typeof getMyClassesFn>;
}

type IComponentProps = DispatchToProps & IOwnProps & IStateToProps;
type PersonGrads = {
  [classId: number]: {
    [phaseTagId: number]: number | undefined;
    effectivity?: number;
  };
};
type AllPersonGrades = {
  [userId: number]: PersonGrads;
};

const pageSize = 50;

const getStatusColor = (status: ParticipantStatus) => {
  switch (status) {
    case 'Approved':
      return '#d4edda';
    case 'Attended':
      return '#fff3cd';
    case 'Rejected':
      return '#f8d7da';
    case 'Dropped':
      return '#e2e3e5';
    default:
      return 'transparent';
  }
};

const MyClassOverview: React.FC<IComponentProps> = ({
  classes,
  getAnalyse,
  tags,
  termId,
  pdpState,
  companyPDP,
  getMyManagingPDPProgram,
  getMyPDPProgram,
  users,
  company,
  thisUser,
  defaultUserId,
  isAdmin,
  requireSeveralUser,
  queryClasses,
  getMyClasses,
  pdpId,
}) => {
  const [loading, setLoading] = useState(new Set<string>());
  const [userId, setUserId] = useState(defaultUserId);

  // const targetUserOptions[] = onlySelf
  //     ? personPrograms![props.thisUser.userId]
  //         ? []
  //         : [Number(props.thisUser.userId)]
  //     : Object.values(props.company.members)
  //         .filter((it) => {
  //           return
  //               (props.isPDPAdmin || managementApplies(it)) &&
  //               Object.keys(it.roles).some((r) => {
  //                 return props?.term?.id
  //                     ? props.pdpState.terms?.[
  //                         props?.term?.id
  //                         ]?.term.properties?.targetRoleIds?.includes(Number(r))
  //                     : false;
  //               });
  //
  //         })
  //         ?.map((it) => it.userId);

  const addLoading = (scope: string) => {
    const newLoading = cloneDeep(loading);
    newLoading.add(scope);
    setLoading(newLoading);
  };

  const removeLoading = (scope: string) => {
    const newLoading = cloneDeep(loading);
    newLoading.delete(scope);
    setLoading(newLoading);
  };
  useEffect(() => {
    addLoading('init');
    const promisses = [] as Promise<any>[];
    promisses.push(getMyPDPProgram(termId, companyPDP.id));
    if (isAdmin) {
      promisses.push(
        queryClasses(companyPDP.id, undefined, undefined, false, termId, false)
      );
      promisses.push(getMyManagingPDPProgram(termId, companyPDP.id));
    } else {
      promisses.push(getMyClasses(termId, companyPDP.id));
    }
    Promise.allSettled(promisses).then(() => {
      removeLoading('init');
    });
  }, [termId]);
  const [baseTagId, targetTagId] = useMemo(() => {
    let base = 0;
    let target = 0;
    Object.values(tags).forEach((it) => {
      if (it.text === 'پیش آزمون' || it.text === 'پیش‌آزمون')
        base = it.id as number;
      if (it.text === 'پس آزمون' || it.text === 'پس‌آزمون')
        target = it.id as number;
    });
    return [base, target];
  }, [tags]);
  const allPhasesIds = Object.values(tags)
    .filter((it) => it.parentId === companyPDP.properties.classPhaseParentTag)
    .map((it) => it.id);

  const [classGrades, setClassGrades] = useState({} as AllPersonGrades);
  const [phaseWithGrade, setPhaseWithGrade] = useState(
    [] as (number | string)[]
  );
  const [totals, setTotals] = useState(
    {} as {
      [key: number]: {
        active: number;
        present: number;
        accepted: number;
        trainingHour: number;
        effectivity: number;
        effectivityCount: number;
        grade: number;
        gradeCount: number;
      };
    }
  );
  const [fetchedUserGrades, setFetchedUserGrades] = useState([] as number[]);
  const fetchUserGrades = (userIds: number[]) => {
    const config = getCurrentOutputConfig();
    const includeOnlyApproved = config.filters.includes('OnlyApproved');

    const newTotal = {};
    if (!classes.length) return;
    if (!userIds.length) return;
    const dataQuery: IAnalyticsQuery = {
      filters: [
        {
          field: 'tags',
          type: 'termFilter',
          values: classes.map((it) => -it.id),
        },
        {
          field: 'instance',
          type: 'termFilter',
          values: userIds,
        },
      ],
      buckets: [
        {
          field: 'instance',
          type: 'bucket',
          name: 'users',
          validBuckets: userIds,
          subBuckets: [
            {
              field: 'tags',
              type: 'bucket',
              name: 'classes',
              validBuckets: classes.map((it) => -it.id),
              subBuckets: [
                {
                  field: 'tags',
                  type: 'bucket',
                  validBuckets: allPhasesIds,
                  name: 'phases',
                },
              ],
            },
          ],
        },
      ],
      metrics: [
        { metric: 'percentageOfTotalAvg', field: 'score', name: 'score' },
      ],
    } as IAnalyticsQuery;
    addLoading('grades');
    getAnalyse(dataQuery, undefined, undefined, classes[0]?.reportToken)
      .then(({ result }) => {
        const foundScoreForPhase = new Set<number>(
          company.pdpPanels
            .find((el) => el.id === pdpId)!
            .properties.classPhaseDefaultProps?.filter(
              (it) => it.phaseWithGrade
            )
            .map((it) => it.phaseTagId)
        );
        const resultUsers = result.categories?.['users'];
        let foundEffective = false;
        const newAllPersonGrades: AllPersonGrades = {};
        userIds.forEach((u) => {
          if (!newTotal[u])
            newTotal[u] = {
              active: 0,
              present: 0,
              accepted: 0,
              trainingHour: 0,
              effectivity: 0,
              gradeCount: 0,
              grade: 0,
            };

          Object.values(classes)
            .filter(
              (c) =>
                !c.deleted &&
                c.participants[u] &&
                c.participants[u].participantProps.status !== 'Dropped' &&
                c.relatedTermIds.includes(termId)
            )
            .forEach((c) => {
              {
                const myMembership = c.participants[u];
                const present =
                  myMembership.participantProps.present || 'unknown';
                if (
                  includeOnlyApproved &&
                  myMembership.participantProps.status !== 'Approved'
                )
                  return;
                newTotal[u].active++;
                newTotal[u].present += present === 'Present' ? 1 : 0;
                newTotal[u].trainingHour += c.properties.trainingHour || 0;
                newTotal[u].accepted +=
                  myMembership.participantProps.status === 'Approved' ? 1 : 0;
                newTotal[u].gradeCount += isANumber(
                  myMembership.participantProps.grade
                )
                  ? 1
                  : 0;
                newTotal[u].grade += myMembership.participantProps.grade || 0;
              }
            });
        });
        if (resultUsers) {
          resultUsers.buckets.forEach((userResponse) => {
            const userId = +userResponse.val;
            const classGrade: PersonGrads = {};
            newAllPersonGrades[userId] = classGrade;
            userResponse.categories['classes'].buckets.forEach((response) => {
              const classId = -Number(response.val);
              const myMembership = classes.find((it) => it.id === classId)
                ?.participants[userId];
              const active =
                myMembership &&
                myMembership?.participantProps.status !== 'Dropped' &&
                (!includeOnlyApproved ||
                  myMembership?.participantProps.status === 'Approved');
              classGrade[classId] = {};
              const phaseScores = new Map<string, number>();
              response.categories['phases'].buckets.forEach((gradeBucket) => {
                const tagId = Number(gradeBucket.val);
                const score = gradeBucket.metrics['score'];
                const tagText = tags[tagId]?.text || '';

                classGrade[classId][tagId] = score;
                foundScoreForPhase.add(tagId);

                if (active) {
                  phaseScores.set(tagText, score);
                }
              });
            });
            userResponse.categories['classes'].buckets.forEach((response) => {
              const classId = -Number(response.val);
              const myMembership = classes.find((it) => it.id === classId)
                ?.participants[userId];
              const active =
                myMembership &&
                myMembership?.participantProps.status !== 'Dropped' &&
                (!includeOnlyApproved ||
                  myMembership?.participantProps.status === 'Approved');
              // main process
              if (active) {
                response.categories['phases'].buckets.forEach((gradeBucket) => {
                  const tagId = Number(gradeBucket.val);
                  const score = gradeBucket.metrics['score'];
                  newTotal[userId][tagId] =
                    (newTotal[userId][tagId] || 0) + score;
                  newTotal[userId]['c' + tagId] =
                    (newTotal[userId]['c' + tagId] || 0) + 1;
                });
              }
              if (
                isANumber(classGrade[classId][baseTagId]) &&
                isANumber(classGrade[classId][targetTagId])
              ) {
                classGrade[classId].effectivity = getEffectivity(
                  classGrade[classId][baseTagId]!,
                  classGrade[classId][targetTagId]!,
                  company,
                  pdpId
                );
                if (active) {
                  newTotal[userId].effectivity =
                    (newTotal[userId].effectivity || 0) +
                    classGrade[classId].effectivity!;
                  newTotal[userId].effectivityCount =
                    (newTotal[userId].effectivityCount || 0) + 1;
                }
                foundEffective = true;
              } else if (
                isANumber(classGrade[classId][targetTagId]) &&
                active
              ) {
                const pdpClass = classes.find((it) => it.id === classId);
                if (pdpClass!.properties.corrective) {
                  const noneCorretvieClassId = classes.find(
                    (it) =>
                      it.relatedTermIds.includes(termId) &&
                      it.topicId === pdpClass!.topicId &&
                      !it.deleted &&
                      !it.properties.corrective &&
                      it.participants[userId] &&
                      it.participants[userId]!.participantProps.status !==
                        'Dropped'
                  )?.id;
                  if (
                    noneCorretvieClassId &&
                    isANumber(classGrade[noneCorretvieClassId]?.[baseTagId])
                  ) {
                    classGrade[classId].effectivity = getEffectivity(
                      classGrade[noneCorretvieClassId][baseTagId]!,
                      classGrade[classId][targetTagId]!,
                      company,
                      pdpId
                    );
                    if (active) {
                      newTotal[userId].effectivity =
                        (newTotal[userId].effectivity || 0) +
                        classGrade[classId].effectivity!;
                      newTotal[userId].effectivityCount =
                        (newTotal[userId].effectivityCount || 0) + 1;
                    }
                    foundEffective = true;
                  }
                }
              }
            });
          });
        }
        setClassGrades(newAllPersonGrades);
        setTotals(newTotal);
        setFetchedUserGrades(userIds);
        const withGradePhase: (string | number)[] = Array.from(
          foundScoreForPhase
        ).sort(
          (a, b) =>
            (tags[a]?.order || Number(tags[a]?.id)) -
            (tags[b]?.order || Number(tags[b]?.id))
        );
        if (foundEffective) withGradePhase.push('effectivity');
        setPhaseWithGrade(withGradePhase);
      })
      .finally(() => {
        removeLoading('grades');
      });
  };

  const getTagOptions = () => {
    const tagOptions: IOption[] = [];
    const slectedCompanyPdp = company.pdpPanels.find((el) => el.id === pdpId)!;
    Object.values(tags).forEach((it: ITagView) => {
      if (
        it.parentId &&
        slectedCompanyPdp.properties.topicTags.includes(it.parentId) &&
        slectedCompanyPdp.properties.topicTagsInPDP.includes(it.parentId)
      ) {
        tagOptions.push({
          value: it.id,
          label: it.text,
          parent: it.parentId,
        });
      } else if (
        slectedCompanyPdp.properties.topicTags.includes(Number(it.id)) &&
        slectedCompanyPdp.properties.topicTagsInPDP.includes(Number(it.id))
      ) {
        tagOptions.push({
          value: it.id,
          label: it.text,
          disabled: true,
        });
      }
    });
    return tagOptions;
  };

  const tagOptions = useMemo(getTagOptions, []);

  const getClassPeriod = (clazz: PDPClass, userId: number) => {
    const participant = clazz.participants[userId];
    const phaseProps = clazz.properties.phaseProps.filter(
      (p) => !p.disabled && !p.adminUsers?.length
    );

    const startDates: number[] = [];
    const endDates: number[] = [];
    const group =
      participant.participantProps.group ||
      clazz.properties.classGroups.length === 1
        ? clazz.properties.classGroups[0].key
        : '';
    phaseProps.forEach((p) => {
      const override = participant?.participantProps.phasePropOverride?.find(
        (o) =>
          o.phaseTagId === p.phaseTagId && o.phaseStageId === p.phaseStageId
      );
      if (override?.startDate) startDates.push(override.startDate);
      else if (p.phaseStartDates[group])
        startDates.push(p.phaseStartDates[group]);

      if (override?.endDate) endDates.push(override.endDate);
      else if (p.phaseEndDates[group]) endDates.push(p.phaseEndDates[group]);
    });

    const start = startDates.length ? Math.min(...startDates) : null;
    const end = endDates.length ? Math.max(...endDates) : null;

    return { start, end };
  };

  const topicOrderMap = useMemo(() => {
    const topics = Object.values(pdpState.topics || {}).map((topic) => ({
      id: topic.id,
      tags: topic.properties.tags
        .slice()
        .sort(
          (a, b) =>
            (tags[a]?.order || 0) - (tags[b]?.order || 0) ||
            tags[a]?.text.localeCompare(tags[b]?.text || '') ||
            0
        ),
    }));

    topics.sort((a, b) => {
      const maxLen = Math.max(a.tags.length, b.tags.length);
      for (let i = 0; i < maxLen; i++) {
        const tagA = a.tags[i] ? tags[a.tags[i]]?.order || 0 : -1;
        const tagB = b.tags[i] ? tags[b.tags[i]]?.order || 0 : -1;
        if (tagA !== tagB) return tagA - tagB;
      }
      return 0;
    });

    const orderMap = new Map<number, number>();
    topics.forEach((topic, index) => orderMap.set(topic.id!, index));
    return orderMap;
  }, [pdpState.topics, tags]);

  function getOrder(a: PDPClass) {
    return (
      (topicOrderMap.get(a.topicId) || 0) +
      (a.properties.corrective ? 0.00000005 : 0)
    );
  }
  const [roleSelectMode, setRoleSelectMode] = useState(false);
  const [showTopicTags, setShowTopicTags] = useState(false);
  const [showDetails, setShowDetails] = useState(true);
  const [showOnlyApprovedCheckBox, setShowOnlyApprovedCheckBox] =
    useState(false);
  const [selectedDistrict, setSelectedDistricts] = useState(new Set<number>());
  const [selectedPost, setSelectedPosts] = useState(new Set<number>());
  const [selectedCategoryTag, setSelectedCategoryTag] = useState<number | null>(
    companyPDP.properties.topicTags[0] || 0
  );
  const [selectedOutputConfig, setSelectedOutputConfig] = useState<string>(
    companyPDP.properties.outputConfigs?.length ? '0' : 'custom'
  );

  const term = pdpState.terms![termId].term!;
  const termTargetRoles = useMemo(
    () => new Set(term.properties!.targetRoleIds || []),
    [termId, pdpState]
  );
  const targetMembers = useMemo(
    () =>
      Object.values(company.members).reduce(
        (current, m) => {
          const userRoles = Object.keys(m.roles);
          if (userRoles.find((it) => termTargetRoles.has(+it)))
            current[m.userId] = m;
          return current;
        },
        {} as { [key: number]: ICompanyMember }
      ),
    [company]
  );
  const allTargetRoles = useMemo(() => {
    const res = new Set<number>();
    Object.values(targetMembers).forEach((it) => {
      Object.keys(it.roles).forEach((r) => {
        res.add(+r);
      });
    });
    return res;
  }, [targetMembers, termTargetRoles]);
  const districtRoleOptions = Object.values(company.roles)
    .filter((it) => it.roleType === 'District' && allTargetRoles.has(it.id))
    .map((it) => ({ value: it.id, label: it.name }));
  const postRoleOptions = Object.values(company.roles)
    .filter((it) => it.roleType === 'Post' && allTargetRoles.has(it.id))
    .map((it) => ({ value: it.id, label: it.name }));

  const userIds = Object.values(company.members)
    .filter((m) => {
      const userRoles = Object.keys(m.roles);
      return (
        userRoles.find((it) => termTargetRoles.has(+it)) &&
        (!selectedDistrict.size ||
          userRoles.find((it) => selectedDistrict.has(+it))) &&
        (!selectedPost.size || userRoles.find((it) => selectedPost.has(+it)))
      );
    })
    .map((it) => it.userId);

  useEffect(() => {
    if (userId && !roleSelectMode) fetchUserGrades([userId]);
  }, [termId, userId, roleSelectMode, selectedOutputConfig]);

  const toShowUsers = fetchedUserGrades;
  const [maxViewCount, setMaxViewCount] = useState(pageSize);
  useEffect(() => {
    setFetchedUserGrades([]);
    setMaxViewCount(pageSize);
  }, [termId]);

  const mx = UserMixpanel.getInstance(Number(thisUser.userId));
  useEffect(() => {
    if (userId && !roleSelectMode && isAdmin) {
      mx.handleAddNumberOfSeenAcademicReports(
        false,
        thisUser.userId === userId.toString()
      );
    } else if (!roleSelectMode && !isAdmin) {
      mx.handleAddNumberOfSeenAcademicReports(false, true);
    }
  }, [termId, userId]);

  if (loading.has('init')) return <LoadingLine />;

  const getCurrentOutputConfig = (): PdpOutputConfig => {
    if (
      selectedOutputConfig !== 'custom' &&
      companyPDP.properties.outputConfigs
    ) {
      return companyPDP.properties.outputConfigs[
        parseInt(selectedOutputConfig)
      ];
    }
    return {
      name: showDetails ? messages.termTranscript : messages.termId,
      fields: [
        'title',
        ...(showTopicTags
          ? companyPDP.properties.topicTags.map((id) => `t_${id}`)
          : []),
        'holdType',
        'period',
        'trainingHour',
        ...(showDetails ? phaseWithGrade.map((id) => `p_${id}`) : []),
        'status',
        ...(showDetails ? ['grade'] : []),
      ],
      group: selectedCategoryTag,
      filters: showOnlyApprovedCheckBox ? ['OnlyApproved'] : [],
      bottomText: '',
    };
  };

  const handleGetDataForExcel = () => {
    const mx = UserMixpanel.getInstance(Number(thisUser.userId));
    mx.handleAddExportAcademicReportCounter();

    const config = getCurrentOutputConfig();
    const includeOnlyApproved = config.filters.includes('OnlyApproved');
    const includeOnlyPresent = config.filters.includes('OnlyPresent');
    const includeOnlyWithClass = config.filters.includes('OnlyWithClass');

    const headerRow = {
      user: messages.name,
      roles: messages.roles,
    };

    config.fields.forEach((field) => {
      if (field === 'title') {
        headerRow['courseTitle'] = messages.courseTitle;
      } else if (field === 'period') {
        headerRow['trainingHour'] = messages.trainingHour;
        headerRow['period'] = messages.period || 'Period';
      } else if (field === 'holdType') {
        headerRow['holdType'] = messages.holdType;
      } else if (field === 'presence') {
        headerRow['presence'] = messages.presence;
      } else if (field === 'effectivity') {
        headerRow['effectivity'] = messages.effectivity;
      } else if (field === 'status') {
        headerRow['status'] = messages.status;
      } else if (field === 'grade') {
        headerRow['grade'] = messages.grade;
      } else if (field.startsWith('t_')) {
        const tagId = parseInt(field.substring(2));
        headerRow['t' + tagId] = tags[tagId]?.text || '';
      } else if (field.startsWith('p_')) {
        const tagId = field.substring(2);
        headerRow['p' + tagId] = tags[tagId]?.text || messages[tagId];
      }
    });

    headerRow['addedInPhase'] = messages.addedInPhase;
    headerRow['presence'] = messages.presence;
    headerRow['status'] = messages.status;
    // headerRow['grade'] = messages.grade;

    const data = [headerRow];
    toShowUsers.forEach((userId) => {
      const allTopics = new Set<number>(
        pdpState.terms![termId].personPrograms[userId]?.properties?.topics?.map(
          (it) => it.topicId
        ) || ([] as number[])
      );
      const userDisplayName =
        users[userId].name +
        (company.members[userId].employeeId
          ? `\n ( ${company.members[userId].employeeId} )`
          : '');
      const roles = Object.keys(company.members[userId].roles)
        .map((it) => company.roles[+it].name)
        .join(', ');

      Object.values(classes)
        .filter(
          (c) =>
            !c.deleted &&
            c.participants[userId!] &&
            c.participants[userId!].participantProps.status !== 'Dropped' &&
            (!includeOnlyApproved ||
              c.participants[userId!].participantProps.status === 'Approved') &&
            (!includeOnlyPresent ||
              c.participants[userId!].participantProps.present === 'Present')
        )
        .sort((a, b) => getOrder(a) - getOrder(b))
        .forEach((clazz) => {
          allTopics.delete(clazz.topicId);
          const myPDPStateForTopic = pdpState.terms![termId].personPrograms[
            userId
          ]?.properties?.topics?.find((it) => it.topicId === clazz.topicId);
          const addedInPhase = term.properties.phaseConfig.phases.find(
            (it) => it.id === myPDPStateForTopic?.addedInPhase
          )?.name;
          const myMembership = clazz.participants[userId!];
          const present = myMembership.participantProps.present || 'unknown';

          const rowData = {
            user: userDisplayName,
            roles: roles,
            addedInPhase: addedInPhase || '-',
            presence: messages[present],
            status:
              messages[clazz.participants[userId!].participantProps.status],
          };

          config.fields.forEach((field) => {
            if (field === 'title') {
              rowData['courseTitle'] =
                pdpState.topics![clazz.topicId!].properties.name +
                (myMembership.participantProps.corrective
                  ? `(${messages.corrective})`
                  : '');
            } else if (field === 'period') {
              const { start, end } = getClassPeriod(clazz, userId);
              rowData['period'] =
                start || end
                  ? smartDateDuration(start, end, false, true, true)
                  : '---';
            } else if (field === 'trainingHour') {
              rowData['trainingHour'] =
                clazz.properties.trainingHour?.toString() || '---';
            } else if (field === 'holdType') {
              rowData['holdType'] = clazz.properties.holdType
                ? tags[clazz.properties.holdType].text
                : '---';
            } else if (field === 'presence') {
              rowData['presence'] = messages[present];
            } else if (field === 'effectivity') {
              rowData['effectivity'] = isANumber(
                classGrades?.[userId]?.[clazz.id]?.effectivity
              )
                ? classGrades[userId][clazz.id].effectivity
                : '---';
            } else if (field === 'status') {
              rowData['status'] =
                messages[clazz.participants[userId!].participantProps.status];
            } else if (field === 'grade') {
              rowData['grade'] =
                clazz.participants[userId!].participantProps.grade;
            } else if (field.startsWith('t_')) {
              const tagId = parseInt(field.substring(2));
              const topicTagValue = pdpState
                .topics![clazz.topicId!].properties.tags.filter(
                  (tid: number) => tags[tid].parentId === tagId
                )
                .map((it) => tags[it].text)
                .join(messages.comma + ' ');
              rowData['t' + tagId] = topicTagValue;
            } else if (field.startsWith('p_')) {
              const tagId = field.substring(2);
              rowData['p' + tagId] = classGrades?.[userId]?.[clazz.id]?.[tagId];
            }
          });

          data.push(rowData);
        });
      if (!includeOnlyWithClass) {
        allTopics.forEach((topicId) => {
          const myPDPStateForTopic = pdpState.terms![termId].personPrograms[
            userId
          ]?.properties?.topics?.find((it) => it.topicId === topicId);
          const rejected = myPDPStateForTopic?.approvedStateByUsers.find(
            (it) => it.approved === 'Rejected'
          );
          const rejectedPhaseName = term.properties.phaseConfig.phases.find(
            (it) => it.id === rejected?.phaseId
          )?.name;
          const addedInPhase = term.properties.phaseConfig.phases.find(
            (it) => it.id === myPDPStateForTopic?.addedInPhase
          )?.name;

          const rowData = {
            user: userDisplayName,
            roles: roles,
            addedInPhase: addedInPhase || '-',
            presence: '---',
            status: rejected
              ? messages.rejectedPDPIn(
                  rejectedPhaseName,
                  users[rejected.userId].name
                )
              : messages.noClass,
            isDisabled: true,
          };

          config.fields.forEach((field) => {
            if (field === 'title') {
              rowData['courseTitle'] =
                pdpState.topics![topicId!].properties.name;
            } else if (field === 'trainingHour') {
              rowData['trainingHour'] = '---';
            } else if (field === 'period') {
              rowData['period'] = '---';
            } else if (field === 'holdType') {
              rowData['holdType'] = '---';
            } else if (field === 'presence') {
              rowData['presence'] = '---';
            } else if (field === 'grade') {
              rowData['grade'] = '---';
            } else if (field.startsWith('t_')) {
              const tagId = parseInt(field.substring(2));
              const topicTagValue = pdpState
                .topics![topicId!].properties.tags.filter(
                  (tid: number) => tags[tid].parentId === tagId
                )
                .map((it) => tags[it].text)
                .join(messages.comma + ' ');
              rowData['t' + tagId] = topicTagValue;
            }
          });

          data.push(rowData);
        });
      }

      const totalRow = {
        user: userDisplayName,
        roles: roles,
        addedInPhase: '',
        presence: `${((totals[userId]?.active ? totals[userId]?.present / totals[userId]?.active : 0) * 100).toFixed(0)} ${messages.percentEn} (${messages.termsEn(convertDigitToProperFormat(totals[userId]?.present))})`,
        status: `${((totals[userId]?.active ? totals[userId]?.accepted / totals[userId]?.active : 0) * 100).toFixed(0)} ${messages.percent} (${messages.termsEn(convertDigitToProperFormat(totals[userId]?.accepted))})`,
        statusColor: 'transparent',
        isTotal: true,
      };

      config.fields.forEach((field) => {
        if (field === 'title') {
          totalRow['courseTitle'] = messages.total;
        } else if (field === 'trainingHour') {
          totalRow['trainingHour'] =
            `${messages.hour} ${totals[userId]?.trainingHour || 0}`;
        } else if (field === 'period') {
          totalRow['period'] = '';
        } else if (field === 'holdType') {
          totalRow['holdType'] = '';
        } else if (field === 'presence') {
          totalRow['presence'] =
            `${((totals[userId]?.active ? totals[userId]?.present / totals[userId]?.active : 0) * 100).toFixed(0)} ${messages.percentEn} (${messages.termsEn(convertDigitToProperFormat(totals[userId]?.present))})`;
        } else if (field === 'effectivity') {
          totalRow['effectivity'] = totals[userId]?.['effectivityCount']
            ? totals[userId].effectivity / totals[userId]?.['effectivityCount']
            : '---';
        } else if (field === 'status') {
          totalRow['status'] =
            `${((totals[userId]?.active ? totals[userId]?.accepted / totals[userId]?.active : 0) * 100).toFixed(0)} ${messages.percent} (${messages.termsEn(convertDigitToProperFormat(totals[userId]?.accepted))})`;
        } else if (field === 'grade') {
          totalRow['grade'] =
            `${((totals[userId]?.active ? totals[userId]?.grade / totals[userId]?.gradeCount : 0) * 100).toFixed(0)} ${messages.percent}`;
        } else if (field.startsWith('t_')) {
          const tagId = parseInt(field.substring(2));
          totalRow['t' + tagId] = '';
        } else if (field.startsWith('p_')) {
          const tagId = field.substring(2);
          const classGradeElement = totals[userId]?.[tagId];
          const classGradeElementCount = totals[userId]?.['c' + tagId];
          const value = classGradeElementCount
            ? classGradeElement! / classGradeElementCount
            : '---';
          totalRow['p' + tagId] = value;
        }
      });

      data.push(totalRow);
    });
    if (term.properties.disableNeedAssessment)
      data.forEach((it) => {
        delete it['addedInPhase'];
      });
    return data;
  };
  return (
    <div
      style={{
        flexGrow: 1,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {isAdmin && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '10px',
            alignItems: 'flex-start',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <Input
              id="batch-mode"
              type="checkbox"
              checked={roleSelectMode}
              onChange={(e) => setRoleSelectMode(e.target.checked)}
              label={messages.batchMode}
            />
            {roleSelectMode ? (
              <div
                style={{
                  display: 'flex',
                  gap: '1rem',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                }}
              >
                <Select
                  options={districtRoleOptions}
                  values={districtRoleOptions.filter((it) =>
                    selectedDistrict.has(+it.value)
                  )}
                  onChangeValues={(v) => {
                    setSelectedDistricts(new Set(v.map((it) => +it.value)));
                  }}
                  label={messages.selectedDistricts}
                  multiChoice={true}
                />
                <Select
                  options={postRoleOptions}
                  values={postRoleOptions.filter((it) =>
                    selectedPost.has(+it.value)
                  )}
                  onChangeValues={(v) => {
                    setSelectedPosts(new Set(v.map((it) => +it.value)));
                  }}
                  label={messages.selectedPosts}
                  multiChoice={true}
                />
                <Button
                  loading={loading.has('grades')}
                  onClick={() => {
                    mx.handleAddNumberOfSeenAcademicReports(true, false);
                    fetchUserGrades(userIds);
                  }}
                >
                  {messages.getResultsFor(userIds.length)}
                </Button>
                <div style={{ flex: 1 }} />
              </div>
            ) : (
              <div style={{ flexGrow: 1 }}>
                <CompanyMemberSelect
                  companyMembers={targetMembers}
                  roleIds={term.properties.targetRoleIds}
                  onSelectUser={(list: number[]) => {
                    setUserId(list[0]);
                  }}
                  label={messages.selectUsersToShowOverview}
                  placeholder={''}
                  selected={userId ? [userId] : []}
                  requireSeveralUser={requireSeveralUser}
                  multiSelect={false}
                  showRoles={false}
                  company={company}
                />
              </div>
            )}
            {!!toShowUsers.length && (
              <div style={{ display: 'flex', gap: '5px' }}>
                <ExportExcell
                  getData={handleGetDataForExcel}
                  exportFileName={
                    toShowUsers.length === 1
                      ? messages.report(
                          users[toShowUsers[0]].name,
                          term.startDate
                            ? moment(term.startDate).format('jYYYY')
                            : term.properties.name,
                          getCurrentOutputConfig().name
                        )
                      : messages.reportGroup(
                          [...selectedDistrict]
                            .map((r) => company.roles[r].name)
                            .join(', '),
                          [...selectedPost]
                            .map((r) => company.roles[r].name)
                            .join(', '),
                          term.startDate
                            ? moment(term.startDate).format('jYYYY')
                            : '',
                          term.properties.name || '',
                          getCurrentOutputConfig().name
                        )
                  }
                  categorizedColumnInformation={{
                    columnNumber: 1,
                    columnTitle: 'user',
                    otherToMergeColumnTitles: ['roles'],
                  }}
                  hasResult={false}
                  body={
                    <Button>
                      <Icon type={'download'} /> {messages.excelExport}
                    </Button>
                  }
                />
                {/*
                <ExportExcell
                  getData={() => handleGetDataForExcel(false, false)}
                  exportFileName={
                    toShowUsers.length === 1
                      ? messages.report(
                          users[toShowUsers[0]].name,
                          term.startDate
                            ? moment(term.startDate).format('jYYYY')
                            : term.properties.name,
                          messages.termId
                        )
                      : messages.reportGroup(
                          [...selectedDistrict]
                            .map((r) => company.roles[r].name)
                            .join(', '),
                          [...selectedPost]
                            .map((r) => company.roles[r].name)
                            .join(', '),
                          term.startDate
                            ? moment(term.startDate).format('jYYYY')
                            : '',
                          term.properties.name || '',
                          messages.termId
                        )
                  }
                  categorizedColumnInformation={{
                    columnNumber: 1,
                    columnTitle: 'user',
                    otherToMergeColumnTitles: ['roles'],
                  }}
                  hasResult={false}
                  body={
                    <Button color="blue">
                      <Icon type={'download'} /> {messages.termId}
                    </Button>
                  }
                />
*/}
              </div>
            )}
          </div>
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '5px',
              justifyContent: 'start',
              margin: '10px',
            }}
          >
            <Select
              options={[
                {
                  value: 'custom',
                  label: i18n.t('custom', { ns: 'companyManagement' }),
                },
                ...(companyPDP.properties.outputConfigs || []).map(
                  (config, index) => ({
                    value: index.toString(),
                    label: config.name,
                  })
                ),
              ]}
              values={[
                {
                  value: selectedOutputConfig,
                  label:
                    selectedOutputConfig === 'custom'
                      ? i18n.t('custom', { ns: 'companyManagement' })
                      : companyPDP.properties.outputConfigs?.[
                          parseInt(selectedOutputConfig)
                        ]?.name || '',
                },
              ]}
              onChangeValues={(values) =>
                setSelectedOutputConfig(values[0]?.value.toString() || 'custom')
              }
              label={
                i18n.t('outputFormat', { ns: 'companyManagement' }) as string
              }
              multiChoice={false}
            />
            {selectedOutputConfig === 'custom' && (
              <>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Input
                    id="show-topic-tags"
                    type="checkbox"
                    checked={showTopicTags}
                    onChange={(e) => setShowTopicTags(e.target.checked)}
                    label={messages.showTopicTags}
                  />
                  <Input
                    id="show-grades"
                    type="checkbox"
                    checked={showDetails}
                    onChange={(e) => setShowDetails(e.target.checked)}
                    label={messages.showDetails}
                  />
                  <Input
                    id="show-only-approved"
                    type="checkbox"
                    checked={showOnlyApprovedCheckBox}
                    onChange={(e) =>
                      setShowOnlyApprovedCheckBox(e.target.checked)
                    }
                    label={messages.showOnlyApprovedCourses}
                  />
                </div>
                {companyPDP.properties.topicTags.length && (
                  <Select
                    options={companyPDP.properties.topicTags.map((tagId) => ({
                      value: tagId,
                      label: tags[tagId]?.text || '',
                    }))}
                    values={
                      selectedCategoryTag
                        ? [
                            {
                              value: selectedCategoryTag,
                              label: tags[selectedCategoryTag]?.text || '',
                            },
                          ]
                        : []
                    }
                    onChangeValues={(values) =>
                      setSelectedCategoryTag(Number(values[0]?.value) || null)
                    }
                    label={messages.categorize}
                    allowRemove={true}
                  />
                )}
              </>
            )}
          </Box>
        </div>
      )}

      {loading.has('grades') && <LoadingLine />}
      {!loading.has('grades') && toShowUsers.length > 0 && (
        <div
          style={{
            width: '100%',
            overflow: 'scroll',
            flex: 1,
          }}
        >
          {toShowUsers.slice(0, maxViewCount).map((userId) => {
            const headerCell = {
              backgroundColor: '#a5a5a5 ',
              fontWeight: 'bold',
              fontSize: '1rem',
            };
            return (
              <Collapsible
                key={userId}
                customHeaderStyle={{ width: '100%' }}
                arrowLocation={'start'}
                header={
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%',
                    }}
                  >
                    <span>
                      {users[userId].name +
                        (company.members[userId].employeeId
                          ? ` ( ${company.members[userId].employeeId} )`
                          : '')}
                    </span>
                    <Icon
                      type="printer"
                      onClick={(e) => {
                        const mx = UserMixpanel.getInstance(
                          Number(thisUser.userId)
                        );
                        mx.handleAddPrintAcademicReportCounter();
                        e.stopPropagation();
                        const printContent = () => {
                          const icon = company?.documents?.find(
                            (it) =>
                              it.properties.displayName.toLowerCase() === 'logo'
                          )?.url;
                          const icon2 = company?.documents?.find(
                            (it) =>
                              it.properties.displayName.toLowerCase() ===
                              'logo2'
                          )?.url;

                          const userRoles = Object.values(
                            company.members[userId].roles
                          )
                            .map((role) => role.name)
                            .join(', ');

                          const tableElement = document.getElementById(
                            `user-table-${userId}`
                          );
                          const tableHTML = tableElement?.innerHTML || '';

                          const linkTags = Array.from(
                            document.querySelectorAll('link[rel="stylesheet"]')
                          )
                            .map((link) => {
                              const newLink = link.cloneNode(
                                true
                              ) as HTMLLinkElement;
                              if (
                                newLink.href &&
                                !newLink.href.startsWith('http')
                              ) {
                                newLink.href = new URL(
                                  newLink.href,
                                  window.location.origin
                                ).href;
                              }
                              return newLink.outerHTML;
                            })
                            .join('\n');

                          const styleTags = Array.from(
                            document.querySelectorAll('style')
                          )
                            .map((style) => style.outerHTML)
                            .join('\n');

                          const printWindow = window.open('', '_blank');
                          printWindow!.document.write(`
                            <html direction="${languageDirection()}" style="direction: ${languageDirection()}" lang="${i18n.language}" >
                              <head>
                                <title>گزارش کلاس‌های ${users[userId].name}</title>
                                  ${linkTags}
                                  ${styleTags}
                                <style>
                                  .header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; border-bottom: 2px solid #333; padding-bottom: 20px; }
                                  .logo { max-height: 80px; max-width: 150px; }
                                  .user-info { text-align: center; }
                                  .user-info h2 { margin: 5px 0; }
                                  .user-info p { margin: 3px 0; color: #666; }
                                  table { font-size: 8pt; border-collapse: collapse !important; }
                                  td { font-size: 8pt; border: 1px solid #000; padding: 4px; }
                                  th { font-size: 9pt !important; border: 1px solid #000; padding: 4px; }
                                  @media print { 
                                    body { margin: 1rem; }
                                    table { page-break-inside: auto; }
                                    thead { display: table-header-group; page-break-inside: avoid; page-break-after: avoid; }
                                    tbody { display: table-row-group; }
                                    tr { page-break-inside: avoid; page-break-after: auto; }
                                  }
                                </style> 
                              </head>
                              <body>
                                <div class="header">
                                  ${icon ? `<img src="${icon}" class="logo" alt="Logo" />` : '<div></div>'}
                                 
                                  <div class="user-info">
                                    
                                    <h5>${showDetails ? messages.termTranscript : messages.termId} ${(term.startDate && moment(term.startDate).format('jYYYY')) || ''}</h5>
                                    <h4>${users[userId].name}</h4>
                                    <h4>${
                                      company.members[userId].employeeId
                                        ? ` ( ${company.members[userId].employeeId} )`
                                        : ''
                                    }</h4>
                                    <p>${company.name}</p>
                                  </div>
                                  ${icon2 ? `<img src="${icon2}" class="logo" alt="Logo 2" />` : '<div></div>'}
                                </div>
                          
                                    <p  style="text-align: center">${messages.roles}: ${userRoles}</p>
                                <table class="highlightedTable">
                                  ${tableHTML}

                                </table>
                                <pre style="white-space: pre-wrap; font-family: inherit; margin: 10px 0;">${getCurrentOutputConfig().bottomText?.replace('%name%', users[userId].name) || ''}</pre>
                              </body>
                            </html>
                          `);
                          printWindow!.document.close();
                          printWindow!.onload = () =>
                            setTimeout(() => printWindow!.print(), 100);
                        };
                        printContent();
                      }}
                      color="black"
                    />
                  </div>
                }
                defaultOpen={true}
                nested={true}
              >
                <div>
                  <ClassOverviewWrapper>
                    {/*<h5>{messages.classStatus}</h5>*/}
                    <table
                      className="highlightedTable"
                      id={`user-table-${userId}`}
                    >
                      <thead>
                        {getCurrentOutputConfig().fields.includes('title') && (
                          <th>{messages.courseTitle}</th>
                        )}
                        {getCurrentOutputConfig()
                          .fields.filter((f) => f.startsWith('t_'))
                          .map((field) => {
                            const tagId = parseInt(field.substring(2));
                            return tagId !== getCurrentOutputConfig().group ? (
                              <th key={tagId}>{tags[tagId]?.text}</th>
                            ) : null;
                          })}
                        {getCurrentOutputConfig().fields.includes(
                          'holdType'
                        ) && <th>{messages.holdType}</th>}
                        {getCurrentOutputConfig().fields.includes('period') && (
                          <th>{messages.period}</th>
                        )}
                        {getCurrentOutputConfig().fields.includes(
                          'trainingHour'
                        ) && <th>{messages.trainingHour}</th>}
                        {getCurrentOutputConfig().fields.includes(
                          'presence'
                        ) && <th>{messages.presence}</th>}
                        {getCurrentOutputConfig()
                          .fields.filter((f) => f.startsWith('p_'))
                          .map((field) => {
                            const tagId = field.substring(2);
                            return (
                              <th key={tagId}>
                                {tags[tagId]?.text || messages[tagId]}
                              </th>
                            );
                          })}
                        {getCurrentOutputConfig().fields.includes(
                          'effectivity'
                        ) && <th>{messages.effectivity}</th>}
                        {getCurrentOutputConfig().fields.includes('grade') && (
                          <th>{messages.grade}</th>
                        )}
                        {getCurrentOutputConfig().fields.includes('status') && (
                          <th>{messages.status}</th>
                        )}
                      </thead>
                      <tbody>
                        {(() => {
                          const config = getCurrentOutputConfig();
                          const filteredClasses = Object.values(classes)
                            .filter(
                              (c) =>
                                !c.deleted &&
                                c.participants[userId] &&
                                c.participants[userId].participantProps
                                  .status !== 'Dropped' &&
                                (!config.filters.includes('OnlyApproved') ||
                                  c.participants[userId].participantProps
                                    .status === 'Approved') &&
                                (!config.filters.includes('OnlyPresent') ||
                                  c.participants[userId].participantProps
                                    .present === 'Present')
                            )
                            .sort((a, b) => getOrder(a) - getOrder(b));

                          const groupedClasses: { [key: string]: PDPClass[] } =
                            {};
                          filteredClasses.forEach((clazz) => {
                            const topic = pdpState.topics![clazz.topicId!];
                            const categoryValue =
                              topic.properties.tags
                                .filter(
                                  (tagId) =>
                                    tags[tagId]?.parentId === config.group
                                )
                                .map((tagId) => tags[tagId]?.text)
                                .join(', ') || '';

                            if (!groupedClasses[categoryValue]) {
                              groupedClasses[categoryValue] = [];
                            }
                            groupedClasses[categoryValue].push(clazz);
                          });

                          return Object.entries(groupedClasses)
                            .map(
                              ([category, classes]: [string, PDPClass[]]) => {
                                const groupAverages = {};
                                let groupCount = 0;
                                let approvedCount = 0;
                                let groupTrainingHour = 0;
                                let presentCount = 0;
                                let finalGradeSum = 0;
                                const gradeCount = {
                                  final: 0,
                                };
                                classes.forEach((clazz) => {
                                  const membership = clazz.participants[userId];
                                  if (membership) {
                                    gradeCount.final += isANumber(
                                      membership.participantProps.grade
                                    )
                                      ? 1
                                      : 0;
                                    finalGradeSum +=
                                      membership.participantProps.grade || 0;
                                    groupCount++;
                                    if (
                                      membership.participantProps.status ===
                                      'Approved'
                                    )
                                      approvedCount++;
                                    if (
                                      membership.participantProps.present ===
                                      'Present'
                                    )
                                      presentCount++;
                                    if (
                                      membership.participantProps.status !==
                                      'Dropped'
                                    ) {
                                      groupTrainingHour +=
                                        clazz.properties.trainingHour || 0;
                                    }
                                    const grades =
                                      classGrades?.[userId]?.[clazz.id];
                                    if (grades) {
                                      phaseWithGrade.forEach((tagId) => {
                                        if (isANumber(grades[tagId])) {
                                          groupAverages[tagId] =
                                            (groupAverages[tagId] || 0) +
                                            grades[tagId];
                                          gradeCount[tagId] =
                                            (gradeCount[tagId] || 0) + 1;
                                        }
                                      });
                                    }
                                  }
                                });
                                Object.keys(groupAverages).forEach((tagId) => {
                                  groupAverages[tagId] =
                                    gradeCount[tagId] > 0
                                      ? groupAverages[tagId] / gradeCount[tagId]
                                      : 0;
                                });
                                const approvedPercent =
                                  groupCount > 0
                                    ? (approvedCount / groupCount) * 100
                                    : 0;
                                const finalGradePercent =
                                  gradeCount.final > 0
                                    ? finalGradeSum / gradeCount.final
                                    : 0;
                                const presentPercent =
                                  groupCount > 0
                                    ? (presentCount / groupCount) * 100
                                    : 0;

                                const nonGradeColumns = config.fields.filter(
                                  (f) =>
                                    f === 'title' ||
                                    f === 'holdType' ||
                                    f === 'period' ||
                                    (f.startsWith('t_') &&
                                      parseInt(f.substring(2)) !== config.group)
                                ).length;

                                return [
                                  (category ||
                                    Object.keys(groupedClasses).length > 1 ||
                                    config.group) && (
                                    <tr key={`category-${category}`}>
                                      <td
                                        style={headerCell}
                                        colSpan={nonGradeColumns}
                                      >
                                        {category}
                                      </td>
                                      {config.fields.includes(
                                        'trainingHour'
                                      ) && (
                                        <td style={headerCell}>
                                          {convertNumbersToProperFormat(
                                            groupTrainingHour,
                                            1
                                          )}
                                        </td>
                                      )}
                                      {config.fields.includes('presence') && (
                                        <td style={headerCell}>
                                          {convertNumbersToProperFormat(
                                            presentPercent,
                                            1
                                          ) + messages.percent}
                                        </td>
                                      )}
                                      {config.fields
                                        .filter((f) => f.startsWith('p_'))
                                        .map((field) => {
                                          const tagId = field.substring(2);
                                          return (
                                            <td key={tagId} style={headerCell}>
                                              {isANumber(groupAverages[tagId])
                                                ? convertNumbersToProperFormat(
                                                    groupAverages[tagId],
                                                    1
                                                  ) + messages.percent
                                                : '---'}
                                            </td>
                                          );
                                        })}
                                      {config.fields.includes(
                                        'effectivity'
                                      ) && <td style={headerCell}>---</td>}
                                      {config.fields.includes('grade') && (
                                        <td style={headerCell}>
                                          {convertNumbersToProperFormat(
                                            finalGradePercent,
                                            1
                                          ) + messages.percent}
                                        </td>
                                      )}
                                      {config.fields.includes('status') && (
                                        <td style={headerCell}>
                                          {convertNumbersToProperFormat(
                                            approvedPercent,
                                            1
                                          ) + messages.percent}
                                        </td>
                                      )}
                                    </tr>
                                  ),
                                  ...classes.map((clazz) => {
                                    const myMembership =
                                      clazz.participants[userId];
                                    const present =
                                      myMembership.participantProps.present ||
                                      'unknown';
                                    return (
                                      <tr key={clazz.id}>
                                        {config.fields.includes('title') && (
                                          <td>
                                            <a
                                              onClick={() =>
                                                navigate(`./class/${clazz.id}`)
                                              }
                                              style={{
                                                cursor: 'pointer',
                                                display: 'flex',
                                                gap: '5px',
                                              }}
                                            >
                                              <span>
                                                {
                                                  pdpState.topics![
                                                    clazz.topicId!
                                                  ].properties.name
                                                }
                                                {(myMembership.participantProps
                                                  .corrective ||
                                                  clazz.properties
                                                    .corrective) &&
                                                  `(${messages.corrective})`}
                                              </span>
                                            </a>
                                          </td>
                                        )}
                                        {config.fields
                                          .filter((f) => f.startsWith('t_'))
                                          .map((field) => {
                                            const tagId = parseInt(
                                              field.substring(2)
                                            );
                                            if (tagId === config.group)
                                              return null;
                                            return (
                                              <td key={tagId}>
                                                {pdpState
                                                  .topics![
                                                    clazz.topicId!
                                                  ].properties.tags.filter(
                                                    (tid: number) =>
                                                      tags[tid]?.parentId ===
                                                      tagId
                                                  )
                                                  .map((tid) => tags[tid]?.text)
                                                  .join(messages.comma + ' ') ||
                                                  '---'}
                                              </td>
                                            );
                                          })}
                                        {config.fields.includes('holdType') && (
                                          <td>
                                            {clazz.properties.holdType
                                              ? tags[clazz.properties.holdType]
                                                  .text
                                              : '---'}
                                          </td>
                                        )}
                                        {config.fields.includes('period') && (
                                          <td>
                                            {(() => {
                                              const { start, end } =
                                                getClassPeriod(clazz, userId);
                                              if (start || end) {
                                                return smartDateDuration(
                                                  start,
                                                  end,
                                                  false,
                                                  true,
                                                  true
                                                );
                                              }
                                              return '---';
                                            })()}
                                          </td>
                                        )}
                                        {config.fields.includes(
                                          'trainingHour'
                                        ) && (
                                          <>
                                            <td>
                                              {isANumber(
                                                clazz.properties.trainingHour
                                              )
                                                ? convertNumbersToProperFormat(
                                                    clazz.properties
                                                      .trainingHour!,
                                                    1
                                                  )
                                                : '---'}
                                            </td>
                                          </>
                                        )}
                                        {config.fields.includes('presence') && (
                                          <td>{messages[present]}</td>
                                        )}
                                        {config.fields
                                          .filter((f) => f.startsWith('p_'))
                                          .map((field) => {
                                            const tagId = Number(
                                              field.substring(2)
                                            );
                                            const classGradeElement =
                                              classGrades?.[userId]?.[
                                                clazz.id
                                              ]?.[tagId];
                                            return (
                                              <th key={tagId}>
                                                {isANumber(classGradeElement)
                                                  ? convertNumbersToProperFormat(
                                                      classGradeElement!,
                                                      1
                                                    ) + messages.percent
                                                  : clazz.properties.phaseProps.find(
                                                        (it) => {
                                                          it.phaseTagId ===
                                                            tagId &&
                                                            !it.disabled;
                                                        }
                                                      )
                                                    ? '---'
                                                    : ''}
                                              </th>
                                            );
                                          })}
                                        {config.fields.includes(
                                          'effectivity'
                                        ) && (
                                          <td>
                                            {isANumber(
                                              classGrades?.[userId]?.[clazz.id]
                                                ?.effectivity
                                            )
                                              ? convertNumbersToProperFormat(
                                                  classGrades[userId][clazz.id]
                                                    .effectivity!,
                                                  1
                                                ) + messages.percent
                                              : '---'}
                                          </td>
                                        )}
                                        {config.fields.includes('grade') && (
                                          <td>
                                            {isANumber(
                                              myMembership.participantProps
                                                .grade
                                            )
                                              ? convertNumbersToProperFormat(
                                                  myMembership.participantProps
                                                    .grade!,
                                                  1
                                                ) + messages.percent
                                              : '---'}
                                          </td>
                                        )}
                                        {config.fields.includes('status') && (
                                          <td
                                            style={{
                                              backgroundColor: getStatusColor(
                                                clazz.participants[userId]
                                                  .participantProps.status
                                              ),
                                            }}
                                          >
                                            {
                                              messages[
                                                clazz.participants[userId]
                                                  .participantProps.status
                                              ]
                                            }
                                          </td>
                                        )}
                                      </tr>
                                    );
                                  }),
                                ];
                              }
                            )
                            .flat();
                        })()}
                        {
                          <tr key={'total'} style={headerCell}>
                            {getCurrentOutputConfig().fields.includes(
                              'title'
                            ) && (
                              <th
                                style={headerCell}
                                colSpan={
                                  getCurrentOutputConfig().fields.filter(
                                    (f) =>
                                      (f.startsWith('t_') ||
                                        f === 'holdType' ||
                                        f === 'period') &&
                                      parseInt(f.substring(2)) !==
                                        getCurrentOutputConfig().group
                                  ).length + 1
                                }
                              >
                                <span>{messages.total}</span>
                              </th>
                            )}
                            {getCurrentOutputConfig().fields.includes(
                              'trainingHour'
                            ) && (
                              <>
                                <th style={headerCell}>
                                  {convertNumbersToProperFormat(
                                    totals[userId]?.trainingHour || 0,
                                    1
                                  )}{' '}
                                  {messages.hour}
                                </th>
                              </>
                            )}
                            {getCurrentOutputConfig().fields.includes(
                              'presence'
                            ) && (
                              <th style={headerCell}>
                                {convertNumbersToProperFormat(
                                  (totals[userId]?.active
                                    ? totals[userId]?.present /
                                      totals[userId]?.active
                                    : 0) * 100,
                                  1
                                )}
                                {messages.percent} (
                                {messages.terms(totals[userId]?.present)})
                              </th>
                            )}
                            {getCurrentOutputConfig()
                              .fields.filter((f) => f.startsWith('p_'))
                              .map((field) => {
                                const tagId = field.substring(2);
                                const classGradeElement =
                                  totals[userId]?.[tagId];
                                const classGradeElementCount =
                                  totals[userId]?.['c' + tagId];
                                return (
                                  <th style={headerCell} key={tagId}>
                                    {classGradeElementCount
                                      ? convertNumbersToProperFormat(
                                          classGradeElement! /
                                            classGradeElementCount,
                                          1
                                        ) + messages.percent
                                      : '---'}
                                  </th>
                                );
                              })}
                            {getCurrentOutputConfig().fields.includes(
                              'effectivity'
                            ) && (
                              <th style={headerCell}>
                                {totals[userId]?.effectivityCount
                                  ? convertNumbersToProperFormat(
                                      totals[userId].effectivity /
                                        totals[userId].effectivityCount,
                                      1
                                    ) + messages.percent
                                  : '---'}
                              </th>
                            )}
                            {getCurrentOutputConfig().fields.includes(
                              'grade'
                            ) && (
                              <th style={headerCell}>
                                <span>
                                  {convertNumbersToProperFormat(
                                    totals[userId]?.gradeCount
                                      ? totals[userId]?.grade /
                                          totals[userId]?.gradeCount
                                      : 0,
                                    1
                                  )}
                                  {messages.percent}
                                </span>
                              </th>
                            )}
                            {getCurrentOutputConfig().fields.includes(
                              'status'
                            ) && (
                              <th style={headerCell}>
                                <span>
                                  {convertNumbersToProperFormat(
                                    (totals[userId]?.active
                                      ? totals[userId]?.accepted /
                                        totals[userId]?.active
                                      : 0) * 100,
                                    1
                                  )}
                                  {messages.percent} (
                                  {messages.terms(totals[userId]?.accepted)})
                                </span>
                              </th>
                            )}
                          </tr>
                        }
                      </tbody>
                    </table>
                  </ClassOverviewWrapper>
                  <div>
                    {pdpState.terms?.[termId]?.personPrograms?.[userId] && (
                      <Collapsible
                        header={
                          <span>
                            <Icon type="database" />
                            {messages.pdpSatusReview}
                          </span>
                        }
                      >
                        <PDPPersonEditor
                          editable={false}
                          addNewTopic={
                            (() => {
                              /*not used*/
                            }) as any
                          }
                          inReportView={true}
                          phase={undefined}
                          availableUsersToAdd={[] as number[]}
                          users={users}
                          new={false}
                          term={term}
                          program={
                            pdpState.terms![termId]?.personPrograms?.[userId]
                          }
                          selectTagOptions={tagOptions}
                          createOrUpdatePDPProgram={
                            (() => {
                              /*do nothing*/
                            }) as any
                          }
                          pdpState={pdpState}
                          thisUser={thisUser}
                          allTags={tags}
                          pdpId={companyPDP.id}
                          company={company}
                          getErrors={() => [] as PDPProblems[]}
                          close={undefined}
                          simple={true}
                        />
                      </Collapsible>
                    )}
                  </div>
                </div>
              </Collapsible>
            );
          })}
          {roleSelectMode && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              {messages.showingPersons(
                Math.min(maxViewCount, toShowUsers.length),
                toShowUsers.length
              )}
              {maxViewCount < toShowUsers.length && (
                <Button
                  color={'green'}
                  onClick={() => {
                    setMaxViewCount(maxViewCount + pageSize);
                  }}
                >
                  {messages.showMore}
                </Button>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  ownProps
) => {
  const providerIds = Object.values(state.providers.map).reduce(
    (current: number[], it) => {
      if (it.data?.managingCompanyId === Number(ownProps.companyId))
        current.push(it.data.id);
      return current;
    },
    [] as number[]
  );
  let tags = {};
  const toLoadTags = [] as number[];
  providerIds.forEach((id: number) => {
    if (!state.providers.tags[id]?.status) toLoadTags.push(id);
    tags = {
      ...tags,
      ...state.providers.tags[id]?.data,
    };
  });
  const companyView = state.companies.data[Number(ownProps.companyId)];
  const company = companyView as ICompany;
  const users = state.users.map;
  const thisUser = state.thisUser as IThisUser;
  const pdpState = state.pdp.pdpMap[ownProps.pdpId];
  const classesInTerm = Object.values(pdpState?.classes || {}).filter((c) =>
    c.relatedTermIds.includes(ownProps.termId)
  );

  return {
    thisUser,
    users,
    company,
    classes: classesInTerm,
    tags,
  };
};
const mapDispatchToProps: MapDispatchToProps<
  DispatchToProps,
  IOwnProps
> = () => {
  return {
    getMyPDPProgram: (termId: number, pdpId: number) =>
      appDispatch(getMyPDPInTerm({ termId, pdpId })),
    getMyManagingPDPProgram: (termId: number, pdpId: number) =>
      appDispatch(getMyManagingPDPInTerm({ termId, pdpId })),
    getAnalyse: (
      dataQuery: IAnalyticsQuery,
      surveyToken?: string,
      ownerToken?: string,
      reportToken?: string
    ) => {
      return appDispatch(
        getAnalyse({ dataQuery, surveyToken, ownerToken, reportToken })
      );
    },
    requireSeveralUser: (usersList: number[]) =>
      appDispatch(requireSeveralUser({ usersList })),
    queryClasses: (
      pdpId: number,
      startDate?: number,
      endDate?: number,
      isTemplate?: boolean,
      termId?: number,
      includeDeleted?: boolean
    ) =>
      appDispatch(
        queryClasses({
          pdpId,
          startDate,
          endDate,
          isTemplate,
          termId,
          includeDeleted,
        })
      ),
    getMyClasses: (termId: number, pdpId: number) =>
      appDispatch(getMyClasses({ pdpId, termId })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyClassOverview);
